<!-- 
程式：ODAVF100.vue
功能：員工獎勵活動網頁
作者：i9400540 施義濃
完成：2020-01-08
-->
<template>
  <div>
    <div v-if="isLogin">
      <web2020Q1WT></web2020Q1WT>
    </div>
  </div>
</template>
<script>
//員工獎勵活動網頁
import web2020Q1WT from "@/components/page/components/webpage/action1/web2020Q1WT.vue";
import DTODAVZ1 from "@/service/DTODAVZ1.js";

export default {
  components: { web2020Q1WT },
  name: "ODAVF100",
  data() {
    return {
      isLogin: false
    };
  },
  mounted() {
    // 取 UserObject
    this.$cathayAxios.post(DTODAVZ1.checkLogin, {}).then(resp => {
      if (resp.returnCode == 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
        window.location =
        window.location.protocol +
        "//" +
        // 導去網投首頁
        window.location.host + "/ODAV/#/ODAVF101";
      }
    });
  }
};
</script>
<style>
</style>